import type { SxProps } from '@mui/material';
import { Box, Tooltip, Typography } from '@mui/material';
import { formatDistanceToNowStrict } from 'date-fns';
import { formatDateFull } from '@/shared/lib';
import { DatasourceStatus, IntegrationStatus } from '../../model/types';
import { StatusIndicator } from '../StatusIndicator/StatusIndicator';

interface Props {
  sx?: SxProps;
  status?: IntegrationStatus;
  lastSuccessfulSync?: string;
}

export function IntegrationSyncInfo({ sx, status, lastSuccessfulSync }: Props) {
  if (status === undefined && !lastSuccessfulSync) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
      {status !== undefined && (
        <StatusIndicator
          status={
            status === IntegrationStatus.failed
              ? DatasourceStatus.error
              : DatasourceStatus.active
          }
        />
      )}
      {lastSuccessfulSync && (
        <Typography
          sx={{
            fontSize: '0.875rem',
            color: '#7E828F',
            whiteSpace: 'nowrap',
          }}
        >
          Last sync:{' '}
          <Tooltip arrow title={formatDateFull(lastSuccessfulSync)}>
            <Typography
              component="span"
              sx={{
                textDecoration: 'underline',
                textDecorationStyle: 'dotted',
                fontSize: 'inherit',
              }}
            >
              {formatDistanceToNowStrict(lastSuccessfulSync)} ago
            </Typography>
          </Tooltip>
        </Typography>
      )}
    </Box>
  );
}
